import { Flex, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import DefaultButton from "components/Button/PrimaryButton";
import { TipoCadastroEmpresa } from "resources/types/empresa";
import DadosGeraisEmpresa from "components/Features/Empresa/FormEmpresa/DadosGerais";
import { showSuccess, showErrorAxios } from "infra/helpers/alerta";
import useFornecedorPessoa from "core/features/fornecedores/hooks/useFornecedorPessoa";
import { EmpresaResponse } from "core/resources/types/empresa";
import { useLoading } from "ui/components/GlobalLoading";
import OutlineButton from "ui/components/Button/OutlineButton";
import history from "infra/helpers/history";
import { useSaveFornecedor } from "features/fornecedores/hooks";
import { PessoaTipo } from "features/pessoas/typings";

interface DadosCadastraisProps {
  id?: string;
  isEdit?: boolean;
}

function DadosCadastrais({ id, isEdit }: DadosCadastraisProps) {
  const { data, isLoading, isFetching } = useFornecedorPessoa(id);

  const { isLoading: isSaveLoading, mutate: handleSave } =
    useSaveFornecedor(id);

  const { control, watch, handleSubmit, setValue, reset } =
    useForm<EmpresaResponse>({
      defaultValues: {
        ativo: true,
        pessoa: {
          contatos: [],
        },
        pessoaTipo: PessoaTipo.Juridica,
      },
    });

  const onSubmit = (data: EmpresaResponse) => {
    handleSave(
      {
        ...data,
        pessoa: {
          ...data.pessoa,
          contatos: Array.isArray(data.pessoa.contatos)
            ? data.pessoa.contatos
            : [],
        },
      },
      {
        onSuccess: (response) => {
          showSuccess().then(() => {
            if (!id && response.data.data) {
              history.replace(`/cadastros/fornecedores/${response.data.data}`);
            }
          });
        },
        onError: (err) => {
          showErrorAxios(err);
        },
      }
    );
  };

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [data, reset]);

  const form = watch();

  useLoading(isLoading || isFetching);

  return (
    <>
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <Text mb="16px" fontSize="18px">
          Dados Cadastrais
        </Text>
        <DadosGeraisEmpresa
          isEdit={isEdit}
          control={control}
          setField={setValue}
          tipoCadastroEmpresa={TipoCadastroEmpresa.Fornecedor}
          isUnidadePessoaEdit={isEdit}
          form={form}
          watch={watch}
          showEndereco
        />

        <Flex mt="16px" gap={4} justifyContent={"flex-end"}>
          <OutlineButton
            onClick={() => history.push(`/cadastros/fornecedores`)}
          >
            Voltar
          </OutlineButton>
          <DefaultButton
            type="submit"
            isLoading={isSaveLoading}
            disabled={isSaveLoading}
          >
            Salvar
          </DefaultButton>
        </Flex>
      </form>
    </>
  );
}

export default DadosCadastrais;
